import { IconComponentProps } from '../IconTypes';

const ScoreCircleThreeQuarter = ({ className }: IconComponentProps) => (
  <svg
    className={className}
    fill="currentColor"
    height="14"
    viewBox="0 0 14 14"
    width="14"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      clipRule="evenodd"
      d="M7.00065 1.37492C3.89405 1.37492 1.37565 3.89332 1.37565 6.99992H7.00065L7.00065 1.37492ZM13.6673 6.99992C13.6673 10.6818 10.6825 13.6666 7.00065 13.6666C3.77899 13.6666 1.09107 11.3814 0.469427 8.34348C0.380621 7.9095 0.333984 7.46016 0.333984 6.99992C0.333984 3.31802 3.31875 0.333252 7.00065 0.333252C10.6825 0.333252 13.6673 3.31802 13.6673 6.99992Z"
      fill="currentColor"
      fillRule="evenodd"
    />
  </svg>
);

export default ScoreCircleThreeQuarter;
